<template>
  <div>
    <table
      :style="cssVars"
      :class="style.borders ? 'bordered' : ''"
      class="combined-report styled-table selectable"
    >
      <thead>
        <tr>
          <th style="min-width: 150px" class="header-title"></th>
          <th class="header-title" v-for="row in tableItems" :key="row.id">
            <span class="" v-text="row.label"></span>
          </th>
          <th class="header-title">Total</th>
        </tr>
      </thead>
      <template v-for="(categ, key) in tableValues">
        <tr :key="rindex + 'C' + key" v-for="(regime, rindex) in categ.regimes">
          <td
            :key="rindex + regime.label"
            :rowspan="categ.regimes.length"
            v-if="rindex === 0"
          >
            {{ categ.label }}
          </td>
          <td :key="rindex + 'label'">
            {{ regime.label }}
          </td>
          <td :key="rindex + 'surg'">{{ regime.surgeonCount }}</td>
          <td :key="rindex + 'help'">{{ regime.helperCount }}</td>
          <td :key="rindex + 'obsr'">{{ regime.observerCount }}</td>
          <td :key="rindex + 'total'">{{ regime.total }}</td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import { GeneralSurgery } from '@/models/GeneralSurgery'
import helpers from '../../mixins/statsHelperFunc'
import { mapGetters } from 'vuex'
export default {
  props: {
    logs: { default: [] },
    logbookType: String
  },
  mixins: [helpers],
  data() {
    return {
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
      rowData: [
        {
          items: [
            { count: 0, component: 'cirgion', group: 1 },
            { count: 0, component: 'helper', group: 2 },
            { count: 0, component: 'observer', group: 1 }
          ]
        }
      ],
      tableItems: [
        { id: 'type', label: 'Regime', component: 'autonomy' },
        { id: 'surgeon', label: 'Cirurgião', component: 'autonomy' },
        { id: 'helper', label: 'Ajudante', component: 'autonomy' },
        { id: 'observer', label: 'Observador', component: 'autonomy' }
      ]
    }
  },
  computed: {
    ...mapGetters(['user']),
    components() {
      return this.allStatsComponents(this.logbookType)
    },
    anatomicalRegions() {
      const tree = GeneralSurgery.query().first().organTree
      return tree.flatMap(n => (n.children ? [...n.children] : [n]))
    },
    tableValues() {
      let items = {}
      this.logs.forEach(log => {
        if (log['anatomic-region']) {
          const fullRegion = this.anatomicalRegions.find(
            item => item.id === log['anatomic-region']
          )
          const region = log['anatomic-region']
          if (!items[region]) {
            items[region] = {
              label: fullRegion.label,
              regimes: [
                {
                  label: 'Electivo',
                  surgeonCount:
                    log['type-of-surgery'] === 'elective' && this.isSurgeon(log)
                      ? 1
                      : 0,
                  helperCount:
                    log['type-of-surgery'] === 'elective' && this.isHelper(log)
                      ? 1
                      : 0,
                  observerCount:
                    log['type-of-surgery'] === 'elective' &&
                    this.isObserver(log)
                      ? 1
                      : 0
                },
                {
                  label: 'Ambulatório',
                  surgeonCount:
                    log['type-of-surgery'] === 'ambulatory' &&
                    this.isSurgeon(log)
                      ? 1
                      : 0,
                  helperCount:
                    log['type-of-surgery'] === 'ambulatory' &&
                    this.isHelper(log)
                      ? 1
                      : 0,
                  observerCount:
                    log['type-of-surgery'] === 'ambulatory' &&
                    this.isObserver(log)
                      ? 1
                      : 0
                },
                {
                  label: 'Urgência',
                  surgeonCount:
                    log['type-of-surgery'] === 'emergency' &&
                    this.isSurgeon(log)
                      ? 1
                      : 0,
                  helperCount:
                    log['type-of-surgery'] === 'emergency' && this.isHelper(log)
                      ? 1
                      : 0,
                  observerCount:
                    log['type-of-surgery'] === 'emergency' &&
                    this.isObserver(log)
                      ? 1
                      : 0
                }
              ]
            }
          } else {
            log['type-of-surgery'] === 'elective' && this.isSurgeon(log)
              ? items[region].regimes[0].surgeonCount++
              : ''
            log['type-of-surgery'] === 'elective' && this.isHelper(log)
              ? items[region].regimes[0].helperCount++
              : ''
            log['type-of-surgery'] === 'elective' && this.isObserver(log)
              ? items[region].regimes[0].observerCount++
              : ''

            log['type-of-surgery'] === 'ambulatory' && this.isSurgeon(log)
              ? items[region].regimes[1].surgeonCount++
              : ''
            log['type-of-surgery'] === 'ambulatory' && this.isHelper(log)
              ? items[region].regimes[1].helperCount++
              : ''
            log['type-of-surgery'] === 'ambulatory' && this.isObserver(log)
              ? items[region].regimes[1].observerCount++
              : ''

            log['type-of-surgery'] === 'emergency' && this.isSurgeon(log)
              ? items[region].regimes[2].surgeonCount++
              : ''
            log['type-of-surgery'] === 'emergency' && this.isHelper(log)
              ? items[region].regimes[2].helperCount++
              : ''
            log['type-of-surgery'] === 'emergency' && this.isObserver(log)
              ? items[region].regimes[2].observerCount++
              : ''
          }
        }
      })

      Object.keys(items).forEach(item => {
        items[item].regimes.map((regime, index) => {
          const total =
            regime.surgeonCount + regime.helperCount + regime.observerCount
          regime.total = total
          if (total === 0) {
            items[item].regimes = items[item].regimes.filter(
              reg => reg.total !== 0
            )
          }
        })
      })
      return items
    },
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--bg-odd-color': this.style.colors[0] + 40,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    }
  },
  methods: {
    isSurgeon(log) {
      if (
        log['surgeon'] === this.user.id ||
        log['surgeon'] === this.user.license
      ) {
        return true
      }
    },
    isHelper(log) {
      if (
        log['helper-1'] === this.user.id ||
        log['helper-1'] === this.user.license
      ) {
        return true
      }
      if (
        log['helper-2'] === this.user.id ||
        log['helper-2'] === this.user.license
      ) {
        return true
      }
      if (
        log['helper-3'] === this.user.id ||
        log['helper-3'] === this.user.license
      ) {
        return true
      }
    },
    isObserver(log) {
      if (
        log['observer'] === this.user.id ||
        log['observer'] === this.user.license
      ) {
        return true
      }
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  }
}
</script>

<style>
.styled-table {
  font-size: 0.9em;
  font-family: sans-serif;
  width: 100%;
  border-collapse: var(--border-collapse);
}
.styled-table.bordered td,
.styled-table.bordered thead {
  border-bottom: 1px solid var(--border-color);
}
.styled-table.bordered tr td,
.styled-table.bordered thead th {
  border-right: 1px solid var(--accent-border-color);
}
.styled-table.bordered tr td:last-child,
.styled-table.bordered thead th:last-child {
  border-right: none;
}
.categ-title {
  background-color: var(--categ-color) !important;
  width: 20px;
  font-weight: bold;
}
.subcateg-title {
  background-color: var(--subcateg-color) !important;
}
.rotate-text {
  writing-mode: vertical-lr;
  -ms-writing-mode: tb-rl;
  transform: rotate(180deg);
}
.combined-report thead th.header-title {
  background-color: var(--categ-color) !important;
}
.combined-report thead th.total {
  background-color: var(--bg-color) !important;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
  text-align: center;
  vertical-align: middle;
}

.odd {
  background-color: var(--bg-odd-color);
}
.even {
  background-color: var(--bg-light-color);
}

tr.total td {
  background-color: var(--bg-odd-color);
}
tr.total td.odd {
  background-color: var(--subcateg-color);
}
.styled-table td.total {
  background-color: var(--subcateg-color);
  font-weight: bold;
  min-width: 70px;
}
.total-cell {
  background-color: var(--categ-color) !important;
  font-weight: bold;
}

.styled-table tr:last-of-type {
  border-bottom: 1px solid var(--border-color);
}
</style>
